
<div class="header-topnav mat-elevation-z2">
  <div class="container">
    <div class="topnav">
      <!-- App Logo -->
      <div class="topbar-branding">
        <img src="../../../../assets/images/jkaw-icon/android-chrome-192x192.png" alt="" class="app-logo">
        <div class="rotated">BETA</div>
      </div>

      <ul class="menu" *ngIf="!layoutConf.isMobile">
        <li *ngFor="let item of menuItems; let i = index;">
          <div *ngIf="item.type !== 'separator'" routerLinkActive="open">
            <a matRipple routerLink="/{{item.state}}" *ngIf="item.type === 'link'">
              <mat-icon>{{item.icon}}</mat-icon>
              {{item.name | translate}}
            </a>
            <div *ngIf="item.type === 'dropDown'">
              <label matRipple for="drop-{{i}}" class="toggle">
                <mat-icon>{{item.icon}}</mat-icon> {{item.name | translate}}
              </label>
              <a matRipple>
                <mat-icon>{{item.icon}}</mat-icon> {{item.name | translate}}
              </a>
              <input type="checkbox" id="drop-{{i}}" />
              <ul>
                <li *ngFor="let itemLvL2 of item.sub; let j = index;" routerLinkActive="open">
                  <a matRipple routerLink="{{item.state ? '/'+item.state : ''}}/{{itemLvL2.state}}"
                    *ngIf="itemLvL2.type !== 'dropDown'">
                    <mat-icon *ngIf="itemLvL2.icon">{{itemLvL2.icon}}</mat-icon>
                    {{itemLvL2.name | translate}}
                  </a>
                  <div *ngIf="itemLvL2.type === 'dropDown'">
                    <label matRipple for="drop-{{i}}{{j}}" class="toggle">{{itemLvL2.name | translate}}</label>
                    <a matRipple>
                      <mat-icon *ngIf="itemLvL2.icon">{{itemLvL2.icon}}</mat-icon> {{itemLvL2.name | translate}}
                    </a>
                    <input type="checkbox" id="drop-{{i}}{{j}}" />
                    <ul>
                      <li *ngFor="let itemLvL3 of itemLvL2.sub" routerLinkActive="open">
                        <a matRipple
                          routerLink="{{item.state ? '/'+item.state : ''}}{{itemLvL2.state ? '/'+itemLvL2.state : ''}}/{{itemLvL3.state}}">
                          <mat-icon *ngIf="itemLvL3.icon">{{itemLvL3.icon}}</mat-icon>
                          {{itemLvL3.name | translate}}
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
      <span fxFlex></span>

      <!-- Badge de ambiente (some em producao) -->
      <span *ngIf="appInfo.isNonProd" class="env-badge" [ngClass]="'env-' + appInfo.info.environmentName"
        matTooltip="Ambiente {{ appInfo.envLabel }} · v{{ appInfo.info.version }} — clique para detalhes"
        (click)="openAbout()">
        {{ appInfo.envLabel }}
      </span>

      <!-- Nome empresa/filial -->
      <span class="empresa-nome" *ngIf="!layoutConf.isMobile" [title]="empresaNomeSessao">
        {{utils.truncate(empresaNomeSessao, 30)}}
      </span>
      <span class="empresa-nome empresa-nome--mobile" *ngIf="layoutConf.isMobile" [title]="empresaNomeSessao">
        {{utils.truncate(empresaNomeSessao, 14)}}
      </span>

      <!-- Language Switcher -->
      <button mat-button [matMenuTriggerFor]="langMenu" class="topbar-button-right" *ngIf="!layoutConf.isMobile">
        <span class="flag-icon {{currentLang?.flag}} mr-05"></span>
        <span>{{currentLang?.name}}</span>
      </button>
      <mat-menu #langMenu="matMenu">
        <button mat-menu-item *ngFor="let lang of availableLangs" (click)="setLang(lang)">
          <span class="flag-icon mr-05 {{lang.flag}}"></span>
          <span>{{lang.name}}</span>
        </button>
      </mat-menu>

      <!-- Theme Switcher -->
      <button mat-icon-button id="schemeToggle" [style.overflow]="'visible'" matTooltip="Color Schemes"
        [matMenuTriggerFor]="themeMenu" class="topbar-button-right">
        <mat-icon>format_color_fill</mat-icon>
      </button>
      <mat-menu #themeMenu="matMenu">
        <mat-grid-list class="theme-list" cols="2" rowHeight="48px">
          <mat-grid-tile *ngFor="let theme of egretThemes" (click)="changeTheme(theme)">
            <div mat-menu-item [title]="theme.name">
              <div [style.background]="theme.baseColor" class="egret-swatch"></div>
              <mat-icon class="active-icon" *ngIf="theme.isActive">check</mat-icon>
            </div>
          </mat-grid-tile>
        </mat-grid-list>
      </mat-menu>

      <!-- Compromissos shortcut -->
      <button mat-icon-button matTooltip="Agenda de Compromissos" [routerLink]="['/utilitario/compromisso']"
        class="topbar-button-right">
        <mat-icon>event_note</mat-icon>
      </button>

      <!-- Notification toggle button -->
      <button mat-icon-button matTooltip="{{'NOTIFICATION' | translate}}" (click)="toggleNotific()"
        [style.overflow]="'visible'" class="topbar-button-right">
        <mat-icon>notifications</mat-icon>
        <span class="notification-number mat-bg-warn" *ngIf="(notificPanel?.totalNotif ?? 0) > 0">
          {{notificPanel.totalNotif}}
        </span>
      </button>

      <!-- User menu -->
      <button mat-icon-button [matMenuTriggerFor]="accountMenu" class="topbar-button-right mr-1 profile-button">
        <img [appImageLoader]="jwtAuth.url + jwtAuth.path + '/image/profile'" alt="" class="profile-img mat-elevation-z1">
      </button>
      <mat-menu #accountMenu="matMenu">
        <button mat-menu-item [routerLink]="['/profile/account']">
          <mat-icon>account_box</mat-icon>
          <span>{{ "ACCOUNT" | translate }}</span>
        </button>
        <button mat-menu-item [routerLink]="['/profile/filial']">
          <mat-icon>swap_vertical_circle</mat-icon>
          <span>{{ "ENTERPRISE" | translate }}</span>
        </button>
        <!-- <mat-divider></mat-divider> -->
        <!-- <button mat-menu-item [routerLink]="['/utilitario/compromisso']">
          <mat-icon>event_note</mat-icon>
          <span>Agenda de Compromissos</span>
        </button> -->
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="openAbout()">
          <mat-icon>info</mat-icon>
          <span>Sobre &middot; v{{ appInfo.info.version }}</span>
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="jwtAuth.signout()">
          <mat-icon>exit_to_app</mat-icon>
          <span>{{ "SIGNOUT" | translate }}</span>
        </button>
      </mat-menu>

      <!-- Mobile sidenav toggle -->
      <!-- <button mat-icon-button class="mr-1" (click)="toggleSidenav()" *ngIf="layoutConf.isMobile">
        <mat-icon>menu</mat-icon>
      </button> -->
    </div>
  </div>
</div>
